import { giphyBlue, giphyIndigo, giphyPurple } from '@giphy/js-brand'
import { Button } from 'shared/components/buttons'
import styled, { css } from 'styled-components'

const baseStyles = css`
    border-radius: 2px;
    box-sizing: border-box;
    padding: 0 36px;
    position: relative;
    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);

    svg {
        display: inline-block;
        vertical-align: middle;
    }
`

const smallButton = css`
    font-size: 16px;
`

export const BlueButton = styled(Button)`
    ${baseStyles}
    ${smallButton}
    background: linear-gradient(45deg, ${giphyIndigo} 0%, ${giphyBlue} 100%);
`

export const PurpleButton = styled(Button)`
    ${baseStyles}
    ${smallButton}
    background: linear-gradient(45deg, ${giphyIndigo} 0%, ${giphyPurple} 100%);
`

export const GenericButton = styled(Button)`
    ${baseStyles}
    ${smallButton}
    background: #000;
    text-shadow: none;
`

export const DownloadButton = styled(Button)`
    ${baseStyles}
    background: linear-gradient(45deg, ${giphyIndigo} 0%, ${giphyPurple} 100%);
    font-family: 'nexablack', sans-serif;
    font-size: 18px;
    font-weight: normal;
    height: 70px;
    line-height: 70px;
    width: 100%;
`
